export type CleaningStaffTaskStatus =
  | "pendiente"
  | "limpio"
  | "solo_ropa"
  | "limpio_y_ropa"
  | "parcial"
  | "no_limpio";

export const CLEANING_STATUS_LABELS: Record<CleaningStaffTaskStatus, string> = {
  pendiente: "Pendiente",
  limpio: "Limpio",
  solo_ropa: "Solo ropa",
  limpio_y_ropa: "Limpio + ropa",
  parcial: "Solo ropa",
  no_limpio: "No se pudo",
};

export const CLEANING_STATUS_DETAIL_LABELS: Record<CleaningStaffTaskStatus, string> = {
  pendiente: "Limpieza pendiente",
  limpio: "Limpieza completa",
  solo_ropa: "Solo cambio de ropa",
  limpio_y_ropa: "Limpieza completa y cambio de ropa",
  parcial: "Solo cambio de ropa",
  no_limpio: "No se pudo limpiar",
};

export const MOTIVO_NO_LIMPIO_LABELS: Record<string, string> = {
  huesped_no_quiso: "Huésped no quiso",
  sin_acceso: "No había acceso",
  falta_ropa_blanca: "Faltó ropa blanca",
  falta_insumo: "Faltó insumo",
  mantenimiento: "Había mantenimiento",
  otro: "Otro",
};

export const MOTIVO_NO_LIMPIO_DETAIL_LABELS: Record<string, string> = {
  huesped_no_quiso: "El huésped no quiso",
  sin_acceso: "No había acceso",
  falta_ropa_blanca: "Faltó ropa blanca",
  falta_insumo: "Faltó un insumo",
  mantenimiento: "Había mantenimiento",
  otro: "Otro motivo",
};

export const MOTIVO_ROPA_LABELS: Record<string, string> = {
  solo_toallas: "Solo toallas",
  solo_sabanas: "Solo sábanas",
  toallas_y_sabanas: "Toallas y sábanas",
  otro: "Otro",
};

export const MOTIVO_ROPA_DETAIL_LABELS: Record<string, string> = {
  solo_toallas: "Solo se cambiaron toallas",
  solo_sabanas: "Solo se cambiaron sábanas",
  toallas_y_sabanas: "Se cambiaron toallas y sábanas",
  otro: "Otro cambio de ropa",
};

export const isLaundryCleaningStatus = (estado: CleaningStaffTaskStatus): boolean =>
  estado === "solo_ropa" || estado === "limpio_y_ropa" || estado === "parcial";

export const isCleaningDoneStatus = (estado: CleaningStaffTaskStatus): boolean =>
  estado === "limpio" || estado === "limpio_y_ropa";

export const isCleaningReasonRequired = (estado: CleaningStaffTaskStatus): boolean =>
  estado === "solo_ropa" ||
  estado === "limpio_y_ropa" ||
  estado === "parcial" ||
  estado === "no_limpio";

export const motivoLabelsPorEstado = (
  estado: CleaningStaffTaskStatus
): Record<string, string> =>
  isLaundryCleaningStatus(estado) ? MOTIVO_ROPA_LABELS : MOTIVO_NO_LIMPIO_LABELS;

/** Insumos que se pueden registrar al marcar una limpieza. */
export const CLEANING_SUPPLY_LABELS = {
  shampoo_recargado: "Shampoo",
  acondicionador_recargado: "Acondicionador",
} as const;

export type CleaningSupplyField = keyof typeof CLEANING_SUPPLY_LABELS;

export const CLEANING_SUPPLY_FIELDS = Object.keys(CLEANING_SUPPLY_LABELS) as CleaningSupplyField[];

export type CleaningSupplies = Record<CleaningSupplyField, boolean>;

export const SIN_INSUMOS: CleaningSupplies = {
  shampoo_recargado: false,
  acondicionador_recargado: false,
};

/** Insumos registrados en una tarea, para precargar el diálogo. */
export const insumosDeTarea = (task: Partial<CleaningSupplies>): CleaningSupplies => ({
  shampoo_recargado: Boolean(task.shampoo_recargado),
  acondicionador_recargado: Boolean(task.acondicionador_recargado),
});

/** "Shampoo y acondicionador", "Shampoo", o "" si no se recargó nada. */
export const resumenInsumos = (task: Partial<CleaningSupplies>): string => {
  const recargados = CLEANING_SUPPLY_FIELDS.filter((campo) => task[campo]);
  if (recargados.length === 0) return "";
  if (recargados.length === CLEANING_SUPPLY_FIELDS.length) return "Shampoo y acondicionador";
  return CLEANING_SUPPLY_LABELS[recargados[0]];
};
